import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { Switch } from "@mui/material";
import PropTypes from "prop-types";
import SoftButton from "components/SoftComponents/SoftButton";
import { setSelectedOrg } from "hooks/context";
import SoftSelect from "components/SoftComponents/SoftSelect";
import moment from "moment-timezone";
import { useSoftUIController } from "hooks/context";

function DeploymentSwitch({ user, selectedOrg, deviceLayout }) {

    const [dispatch, controller] = useSoftUIController();
    const { appearance } = controller;

    return (
        <SoftBox p={1} sx={{
            height: deviceLayout == 'mobile' ? 'unset' : 'calc(100svh - 12.1rem - 16px)',
            overflowY: 'auto',
            width: deviceLayout == 'mobile' ? 'unset' : 'calc(100svw - 260px - 64px)',
        }}>
            <SoftBox px={{ xxs: 2, lg: 3 }} pb={{ xxs: 2, lg: 3 }} pt={3} sx={{ borderRadius: "1rem" /*, backgroundColor: "#f9f9f9" */ }}>
                <SoftBox mb={3} textAlign="left" display="flex" flexDirection="column">
                    <SoftTypography variant="subtitle3" fontWeight="medium" color="text" display={deviceLayout == 'mobile' ? 'block' : 'none'}>Account Settings</SoftTypography>
                    <SoftTypography variant="h4" fontWeight="bold" color={appearance}>Deployment Selection</SoftTypography>
                    <SoftTypography variant="button" fontWeight="regular" color="text">Change which deployment you are viewing</SoftTypography>
                </SoftBox>
                <SoftBox sx={{ width: { xxs: "100%", md: "300px" } }}>
                    <SoftSelect
                        bgColor="white"
                        value={{ value: selectedOrg, label: user.organisations.find(row => row.organisation_id == selectedOrg).label }}
                        options={[
                            ...user.organisations.map(org => ({ value: org.organisation_id, label: org.label }))
                        ]}
                        onChange={(opt) => {
                            setSelectedOrg(dispatch, opt.value)
                            moment.tz.setDefault(user.organisations.find(row => row.organisation_id == opt.value).timezone);
                            localStorage.setItem("selectedOrg", opt.value);
                        }}
                    />
                </SoftBox>
            </SoftBox>
        </SoftBox>
    );
}


DeploymentSwitch.propTypes = {
    user: PropTypes.object,
    selectedOrg: PropTypes.string,
    deviceLayout: PropTypes.string,
}

export default DeploymentSwitch;